/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { IDToken } from '@okta/okta-auth-js';
import AircraftTailTagDefault from './AircraftTailTagDefault';
import AircraftTailTagLinkway from './AircraftTailTagLinkway';
import { NetworkGroup } from '../../shared/entities/terminal';
import { TerminalPlatformsEnum } from '../../shared/entities/terminalPlatform';
import AircraftTailTagSpaceVehicle from './AircraftTailTagSpaceVehicle';

interface AircraftTailTagProps {
  terminalNum: number; // The terminal number on the aircraft 1 to n or undefined if only 1 terminal
  datapathUuid: string;
  networkGroup: NetworkGroup;
  platformType: TerminalPlatformsEnum;
  userData: IDToken | undefined;
}

/**
 * This class represents the styling and DOM for the aircraft tail tag on google maps.
 */
const AircraftTailTag = (props: AircraftTailTagProps): React.ReactComponentElement<'div', {}> => {
  const { terminalNum, datapathUuid, networkGroup, platformType, userData } = props;

  if (networkGroup === NetworkGroup.LINKWAY) {
    return (
      <div
        data-test={`map--tailtag-${datapathUuid}--idx-${terminalNum}`}
        className={`map__tailtag map__tailtag${terminalNum}`}
      >
        <AircraftTailTagLinkway terminalNum={terminalNum} datapathUuid={datapathUuid} />
      </div>
    );
  } else if (platformType === TerminalPlatformsEnum.SpaceVehicle) {
    return (
      <div
        data-test={`map--tailtag-${datapathUuid}--idx-${terminalNum}`}
        className={`map__tailtag map__tailtag${terminalNum}`}
      >
        <AircraftTailTagSpaceVehicle terminalNum={terminalNum} datapathUuid={datapathUuid} />
      </div>
    );
  }
  return (
    <div
      data-test={`map--tailtag-${datapathUuid}--idx-${terminalNum}`}
      className={`map__tailtag map__tailtag${terminalNum}`}
    >
      <AircraftTailTagDefault terminalNum={terminalNum} datapathUuid={datapathUuid} userData={userData} />
    </div>
  );
};

export default AircraftTailTag;
